import { IBillMoney } from '../../types'
import {TApiEnums} from '../../../services/_common'

export function parseBillMoney(response: TApiEnums): IBillMoney[] {
    return response.entities.map((item) => ({
        id: item['@id'],
        text: item.text,
    }))
}